/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_itemSearch = {
    readonly popularSearchesLink: {
        readonly " $fragmentRefs": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
    };
    readonly " $refType": "SharedMobileLinksBlock_itemSearch";
};
export type SharedMobileLinksBlock_itemSearch$data = SharedMobileLinksBlock_itemSearch;
export type SharedMobileLinksBlock_itemSearch$key = {
    readonly " $data"?: SharedMobileLinksBlock_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileLinksBlock_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileLinksBlock_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '21ed6b0010e1e2a4de07a59d1c209103';
export default node;
